export const selectCalc = ({review}) => review?.calc;
